import React from 'react';

export default function ReadOnlySvg(props) {
  return (
    <svg
      width="451px"
      height="282px"
      viewBox="0 0 451 282"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      {/* Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch */}
      <title>Group 107</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <polygon
          id="path-1"
          points="9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59"
        />
        <polygon
          id="path-3"
          points="9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59"
        />
        <polygon
          id="path-5"
          points="9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59"
        />
        <path
          d="M3.83107143,3.04993878 C-0.493,6.76934694 -0.544,12.536898 1.56035714,18.6223265 C2.39092857,21.0208571 3.39635714,23.156898 4.31071429,24.8666939 C5.64764286,27.3627551 5.91964286,30.503 4.91057143,33.2121837 C3.349,37.4132245 2.13107143,44.2331429 6.73442857,50.7231429 C9.43742857,54.5352653 12.3189286,55.8308571 14.8810714,55.9452449 C16.1463571,56.0006327 17.3618571,56.4581837 18.4061429,57.3154898 C19.8972857,58.5412449 21.8729286,59.4093878 24.2711429,58.8013265 C26.4568571,58.2462449 27.9419286,56.5545102 28.9425,54.6616939 C29.6176429,53.3889796 29.3978571,48.9639796 30.4664286,48.1632653 C31.8276429,47.141 35.9732143,43.9923265 31.6807143,39.7346939 C25.6080714,33.7142857 28.0366429,33.7142857 28.0366429,31.3061224 C28.0366429,30.1273265 25.9820714,27.744449 25.6080714,26.4897959 C25.2862857,25.4073265 26.367,21.8119388 25.6080714,20.4693878 C24.6208571,18.7186531 21.7988571,16.3116939 20.7521429,15.6530612 C19.1189286,14.6271837 19.3921429,12.375551 18.7922857,10.2888776 C18.054,7.72057143 16.7401429,4.49965306 14.5374286,2.78142857 C12.7451429,1.38228571 10.9856429,0.804326531 9.33785714,0.804326531 C7.27721429,0.804326531 5.39021429,1.70979592 3.83107143,3.04993878"
          id="path-7"
        />
      </defs>
      <g
        id="School-Onboarding"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="School-Setup_user-return"
          transform="translate(-495.000000, -556.000000)"
        >
          <g id="Group-107" transform="translate(495.000000, 556.000000)">
            <g id="Group-45">
              <path
                d="M449.315797,250.532189 C464.687422,262.385871 366.309743,252.95279 234.33662,266.992275 C105.532332,280.695296 8.97594652,268.350232 0.113604278,249.341253 C-3.95197861,240.622249 101.807561,231.010043 234.33662,231.690232 C368.752235,232.377682 405.372695,216.643777 449.315797,250.532189"
                id="Fill-1"
                fill="#DFE1E7"
              />
              <path
                d="M357.620225,246.701588 L81.3019893,246.701588 C73.1708235,246.701588 66.5793583,240.100609 66.5793583,231.957708 L66.5793583,12.3390129 C66.5793583,10.1653133 68.339016,8.40311588 70.5095829,8.40311588 L366.848759,8.40311588 C369.882235,8.40311588 372.344064,10.8672876 372.344064,13.9063519 L372.344064,231.957708 C372.344064,240.100609 365.752599,246.701588 357.620225,246.701588"
                id="Fill-3"
                fill="#FCFCFD"
              />
              <path
                d="M373.552137,20.6637013 L66.5788749,20.6637013 L66.5788749,11.2887142 C66.5788749,5.55915193 71.2161048,0.915229185 76.9374096,0.915229185 L363.567046,0.915229185 C369.081688,0.915229185 373.552137,5.39213047 373.552137,10.913521 L373.552137,20.6637013 Z"
                id="Fill-5"
                fill="#757C99"
              />
              <path
                d="M81.9838567,11.4476266 C81.9838567,12.9024077 80.9227444,14.0812403 79.6138781,14.0812403 C78.3050118,14.0812403 77.2438995,12.9024077 77.2438995,11.4476266 C77.2438995,9.99284549 78.3050118,8.81401288 79.6138781,8.81401288 C80.9227444,8.81401288 81.9838567,9.99284549 81.9838567,11.4476266"
                id="Fill-7"
                fill="#F0F2F6"
              />
              <path
                d="M90.2784193,11.4476266 C90.2784193,12.9024077 89.217307,14.0812403 87.9084406,14.0812403 C86.5995743,14.0812403 85.538462,12.9024077 85.538462,11.4476266 C85.538462,9.99284549 86.5995743,8.81401288 87.9084406,8.81401288 C89.217307,8.81401288 90.2784193,9.99284549 90.2784193,11.4476266"
                id="Fill-9"
                fill="#FFEFC8"
              />
              <path
                d="M98.5731027,11.4476266 C98.5731027,12.9024077 97.5119904,14.0812403 96.2031241,14.0812403 C94.8942578,14.0812403 93.8331455,12.9024077 93.8331455,11.4476266 C93.8331455,9.99284549 94.8942578,8.81401288 96.2031241,8.81401288 C97.5119904,8.81401288 98.5731027,9.99284549 98.5731027,11.4476266"
                id="Fill-11"
                fill="#FCC35D"
              />
              <path
                d="M122.104399,83.4461545 L94.1380845,83.4461545 C92.4051291,83.4461545 91,80.4022489 91,76.6466867 L91,46.7994678 C91,43.0439056 92.4051291,40 94.1380845,40 L122.104399,40 C123.837354,40 125.242483,43.0439056 125.242483,46.7994678 L125.242483,76.6466867 C125.242483,80.4022489 123.837354,83.4461545 122.104399,83.4461545"
                id="Fill-13"
                fill="#DFE1E7"
              />
              <path
                d="M338.724675,49.6282481 L142.124564,49.6282481 C139.250637,49.6282481 136.920868,47.7317073 136.920868,45.3921966 L136.920868,44.6478618 C136.920868,42.3083511 139.250637,40.4118103 142.124564,40.4118103 L338.724675,40.4118103 C341.598602,40.4118103 343.928371,42.3083511 343.928371,44.6478618 L343.928371,45.3921966 C343.928371,47.7317073 341.598602,49.6282481 338.724675,49.6282481"
                id="Fill-15"
                fill="#DFE1E7"
              />
              <path
                d="M285.547952,64.1104609 L142.123672,64.1104609 C139.251232,64.1104609 136.919976,62.2139202 136.919976,59.8744094 L136.919976,59.1300747 C136.919976,56.7917742 139.251232,54.8940232 142.123672,54.8940232 L285.547952,54.8940232 C288.42188,54.8940232 290.751649,56.7917742 290.751649,59.1300747 L290.751649,59.8744094 C290.751649,62.2139202 288.42188,64.1104609 285.547952,64.1104609"
                id="Fill-17"
                fill="#DFE1E7"
              />
              <path
                d="M285.547952,79.9093597 L142.123672,79.9093597 C139.251232,79.9093597 136.919976,78.0128189 136.919976,75.6733082 L136.919976,74.9289734 C136.919976,72.5894627 139.251232,70.6929219 142.123672,70.6929219 L285.547952,70.6929219 C288.42188,70.6929219 290.751649,72.5894627 290.751649,74.9289734 L290.751649,75.6733082 C290.751649,78.0128189 288.42188,79.9093597 285.547952,79.9093597"
                id="Fill-19"
                fill="#DFE1E7"
              />
              <path
                d="M338.724675,115.456609 L142.124564,115.456609 C139.250637,115.456609 136.920868,113.560069 136.920868,111.220558 L136.920868,110.476223 C136.920868,108.137923 139.250637,106.240172 142.124564,106.240172 L338.724675,106.240172 C341.598602,106.240172 343.928371,108.137923 343.928371,110.476223 L343.928371,111.220558 C343.928371,113.560069 341.598602,115.456609 338.724675,115.456609"
                id="Fill-23"
                fill="#DFE1E7"
              />
              <path
                d="M285.547952,129.938822 L142.123672,129.938822 C139.251232,129.938822 136.919976,128.042282 136.919976,125.702771 L136.919976,124.959646 C136.919976,122.620136 139.251232,120.723595 142.123672,120.723595 L285.547952,120.723595 C288.42188,120.723595 290.751649,122.620136 290.751649,124.959646 L290.751649,125.702771 C290.751649,128.042282 288.42188,129.938822 285.547952,129.938822"
                id="Fill-25"
                fill="#DFE1E7"
              />
              <path
                d="M285.547952,145.737842 L142.123672,145.737842 C139.251232,145.737842 136.919976,143.841301 136.919976,141.501791 L136.919976,140.757456 C136.919976,138.419155 139.251232,136.521404 142.123672,136.521404 L285.547952,136.521404 C288.42188,136.521404 290.751649,138.419155 290.751649,140.757456 L290.751649,141.501791 C290.751649,143.841301 288.42188,145.737842 285.547952,145.737842"
                id="Fill-27"
                fill="#DFE1E7"
              />
              <path
                d="M122.104399,218.447365 L94.1380845,218.447365 C92.4051291,218.447365 91,215.402249 91,211.646687 L91,181.800678 C91,178.045116 92.4051291,175 94.1380845,175 L122.104399,175 C123.837354,175 125.242483,178.045116 125.242483,181.800678 L125.242483,211.646687 C125.242483,215.402249 123.837354,218.447365 122.104399,218.447365"
                id="Fill-29"
                fill="#DFE1E7"
              />
              <g
                id="Icon/Action/Check"
                transform="translate(96.000000, 185.000000)"
              >
                <g id="ic_check">
                  <g id="Icon-24px">
                    <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                    <mask id="mask-2" fill="white">
                      <use xlinkHref="#path-1" />
                    </mask>
                    <use id="Shape" fill="#000000" xlinkHref="#path-1" />
                    <g
                      id="Color-/-Prussian-600"
                      mask="url(#mask-2)"
                      fill="#757D99"
                    >
                      <polygon id="757D99" points="0 0 24 0 24 24 0 24" />
                    </g>
                  </g>
                </g>
              </g>
              <path
                d="M338.724675,183.918342 L142.124564,183.918342 C139.250637,183.918342 136.920868,182.021802 136.920868,179.682291 L136.920868,178.937956 C136.920868,176.599656 139.250637,174.701905 142.124564,174.701905 L338.724675,174.701905 C341.598602,174.701905 343.928371,176.599656 343.928371,178.937956 L343.928371,179.682291 C343.928371,182.021802 341.598602,183.918342 338.724675,183.918342"
                id="Fill-31"
                fill="#DFE1E7"
              />
              <path
                d="M285.547952,198.400676 L142.123672,198.400676 C139.251232,198.400676 136.919976,196.504136 136.919976,194.164625 L136.919976,193.4215 C136.919976,191.080779 139.251232,189.185449 142.123672,189.185449 L285.547952,189.185449 C288.42188,189.185449 290.751649,191.080779 290.751649,193.4215 L290.751649,194.164625 C290.751649,196.504136 288.42188,198.400676 285.547952,198.400676"
                id="Fill-33"
                fill="#DFE1E7"
              />
              <path
                d="M285.547952,214.199575 L142.123672,214.199575 C139.251232,214.199575 136.919976,212.303034 136.919976,209.963524 L136.919976,209.220399 C136.919976,206.879678 139.251232,204.984348 142.123672,204.984348 L285.547952,204.984348 C288.42188,204.984348 290.751649,206.879678 290.751649,209.220399 L290.751649,209.963524 C290.751649,212.303034 288.42188,214.199575 285.547952,214.199575"
                id="Fill-35"
                fill="#DFE1E7"
              />
              <path
                d="M378.386361,266.97763 C378.386361,275.273029 352.143773,281.999879 319.771388,281.999879 C306.295987,281.999879 293.875656,276.881518 283.982415,278.874883 C268.483891,281.999879 261.156415,271.820042 261.156415,266.97763 C261.156415,258.681021 287.940436,258.546677 319.771388,251.954171 C352.742009,245.125656 378.386361,258.681021 378.386361,266.97763"
                id="Fill-37"
                fill="#DFE1E7"
              />
              <path
                d="M122.104399,149.447365 L94.1380845,149.447365 C92.4051291,149.447365 91,146.402249 91,142.646687 L91,112.800678 C91,109.045116 92.4051291,106 94.1380845,106 L122.104399,106 C123.837354,106 125.242483,109.045116 125.242483,112.800678 L125.242483,142.646687 C125.242483,146.402249 123.837354,149.447365 122.104399,149.447365"
                id="Fill-21"
                fill="#DFE1E7"
              />
              <g
                id="Icon/Action/Check"
                transform="translate(96.000000, 50.000000)"
              >
                <g id="ic_check">
                  <g id="Icon-24px">
                    <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                    <mask id="mask-4" fill="white">
                      <use xlinkHref="#path-3" />
                    </mask>
                    <use id="Shape" fill="#000000" xlinkHref="#path-3" />
                    <g
                      id="Color-/-Prussian-600"
                      mask="url(#mask-4)"
                      fill="#757D99"
                    >
                      <polygon id="757D99" points="0 0 24 0 24 24 0 24" />
                    </g>
                  </g>
                </g>
              </g>
              <g
                id="Icon/Action/Check"
                transform="translate(96.000000, 116.000000)"
              >
                <g id="ic_check">
                  <g id="Icon-24px">
                    <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                    <mask id="mask-6" fill="white">
                      <use xlinkHref="#path-5" />
                    </mask>
                    <use id="Shape" fill="#000000" xlinkHref="#path-5" />
                    <g
                      id="Color-/-Prussian-600"
                      mask="url(#mask-6)"
                      fill="#757D99"
                    >
                      <polygon id="757D99" points="0 0 24 0 24 24 0 24" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="Group-94" transform="translate(307.000000, 129.000000)">
              <path
                d="M6.24730566,130.526163 C6.24730566,130.526163 7.27855094,133.326343 6.68806038,133.990402 C6.09998491,134.653253 0.507833962,134.431899 0.435381132,133.842834 C0.361720755,133.253768 4.4818717,130.747516 4.4818717,130.747516 L6.24730566,130.526163 Z"
                id="Fill-76"
                fill="#757C99"
              />
              <path
                d="M33.4772528,131.296303 C33.7718943,132.40186 34.0653283,134.39283 33.4772528,134.686758 C32.8891774,134.981896 27.0035925,134.612974 27.0760453,134.023908 C27.1497057,133.433632 31.5306868,131.16204 31.5306868,131.16204 L33.4772528,131.296303 Z"
                id="Fill-78"
                fill="#757C99"
              />
              <path
                d="M3.92893585,131.161677 L6.50342642,131.234251 C6.50342642,131.234251 9.63821887,103.733222 11.8142189,99.7198323 C13.9950491,95.7003952 22.8898415,76.5708743 22.8898415,76.5708743 C22.8898415,76.5708743 21.0604075,92.1176168 22.7159547,99.3690539 C24.3715019,106.620491 31.2448604,131.448347 31.2448604,131.448347 L33.5331623,131.663653 C33.5331623,131.663653 33.0066717,111.421317 33.0912,103.213102 C33.1672755,96.3680838 35.7224453,80.0508383 35.5666717,70.1068743 C35.5280302,68.1219521 35.3867472,66.3910419 35.0981434,65.0411497 C34.4738415,62.1212216 33.2240302,59.8883353 31.8800302,58.23 C29.4963321,55.2725749 26.8131623,54.1258922 26.8131623,54.1258922 L9.63821887,55.693509 C9.63821887,55.693509 1.09240755,92.1176168 0.917313208,96.5712934 C0.742218868,101.027389 3.92893585,131.161677 3.92893585,131.161677"
                id="Fill-80"
                fill="#47506B"
              />
              <polygon
                id="Fill-82"
                fill="#2D344B"
                points="25.2449208 59.8885772 15.6533736 61.1114635 16.9611472 68.2746012 21.9314113 72.0291401 26.7277887 68.8842299"
              />
              <path
                d="M29.8781585,59.0935198 L32.1314415,68.6238072 L35.5669132,70.1067533 C35.5282717,68.1218311 35.3869887,66.390921 35.0971774,65.0410287 C34.474083,62.1211006 33.2242717,59.8882144 31.8802717,58.229879 L29.8781585,59.0935198 Z"
                id="Fill-84"
                fill="#2D344B"
              />
              <path
                d="M10.3133585,6.79451018 C9.96196226,10.4559114 12.6390943,13.7084743 16.2943396,14.0616719 C19.9483774,14.4136599 23.1966792,11.7308096 23.5480755,8.07061796 C23.8994717,4.40921677 21.2223396,1.15544431 17.5670943,0.803456287 C13.9118491,0.451468263 10.6647547,3.13431856 10.3133585,6.79451018"
                id="Fill-86"
                fill="#FFCDAB"
              />
              <polygon
                id="Fill-88"
                fill="#FFCDAB"
                points="14.1612075 11.9990946 11.9308679 20.0500647 18.3441509 20.6681605 17.9384151 13.0925557"
              />
              <path
                d="M21.1211472,16.5911473 C19.8133736,16.2415784 15.6280151,15.8049198 10.3087698,18.4248719 C4.99073208,21.0460335 2.38484528,24.2223928 1.76416604,28.7317102 C1.14831698,33.2011114 5.80582642,34.8292072 5.80582642,34.8292072 C5.80582642,34.8292072 8.4781283,44.6292311 9.08793962,48.4720695 C9.69895849,52.3149078 9.52386415,55.9835665 9.52386415,55.9835665 C9.52386415,55.9835665 9.52386415,56.9439737 19.1166189,56.6814946 C28.708166,56.4202251 27.836317,54.4111114 27.836317,54.4111114 C27.836317,54.4111114 27.4861283,39.1256383 27.5742792,34.6707521 C27.6612226,30.2170754 27.9232604,22.2677102 27.9232604,22.2677102 L21.1211472,16.5911473 Z"
                id="Fill-90"
                fill="#FAA918"
              />
            </g>
            <g
              id="Group-97"
              transform="translate(339.840860, 147.900216) rotate(-19.000000) translate(-339.840860, -147.900216) translate(322.840860, 117.900216)"
            >
              <path
                d="M3.99849057,2.75273293 C6.78913208,0.329942515 10.6339623,-0.678847904 14.645434,2.48299641 C16.8359245,4.20906826 18.1424906,7.44348743 18.8766792,10.0247329 C19.4732075,12.1221461 19.2015094,14.3816431 20.8256604,15.4134156 C21.866566,16.0750563 24.6729057,18.4930084 25.6558491,20.2517389 C26.4093585,21.6004216 25.3346415,25.2122299 25.6558491,26.2996431 C26.026566,27.5600263 28.0709434,29.9537868 28.0709434,31.1379665 C28.0709434,33.5571281 25.6558491,33.5571281 31.6935849,39.6050323 C35.9622642,43.8809006 31.8409057,47.0451641 30.4860377,48.0720982 C29.4233962,48.8764695 29.6407547,53.3204695 28.9717736,54.600206 C27.9743396,56.5016671 26.498717,58.2011281 24.3251321,58.7587449 C21.9402264,59.3695832 19.9755472,58.4974754 18.4926792,57.2661222 C17.4541887,56.403691 16.2466415,55.9452599 14.9871698,55.8896192 C12.4380377,55.774709 9.57373585,54.4732 6.88573585,50.6436671 C2.30792453,44.1228168 3.52030189,37.2729605 5.07320755,33.0527329 C6.0754717,30.331176 5.80498113,27.1765892 4.47667925,24.6691281 C3.56618868,22.9515234 2.56513208,20.8045174 1.74037736,18.3962419 C-0.352301887,12.2830204 -0.302792453,6.48912814 3.99849057,2.75273293"
                id="Fill-92"
                fill="#47506B"
              />
              <mask id="mask-8" fill="white">
                <use xlinkHref="#path-7" />
              </mask>
              <g id="Clip-96" />
              <path
                d="M-4.72587857,13.8281551 C-2.77695,11.3730327 -1.10609286,-4.8158449 3.49362143,12.8191347 C4.08376429,15.0816041 6.63255,17.189951 7.42547857,19.5403184 C8.07026429,21.4499918 9.18497857,22.9827878 10.5316214,23.8280531 C11.3949786,24.3698898 12.4028357,25.2910122 13.3159786,26.8587265 C14.0178357,28.0604 11.9086214,30.316849 12.25105,31.3066041 C12.9237643,33.2487878 10.1503357,37.0019102 9.82247857,37.3270122 C8.60819286,38.5310939 9.96697857,43.2137673 11.0367643,44.551502 C13.2613357,47.3281143 21.4274071,47.0415429 19.5367643,54.1841551 C18.9369071,56.4502367 27.7817643,57.9481143 26.8224786,59.0004816 C26.0708357,59.8240735 19.52705,59.0823592 19.11905,60.3213592 C18.5131214,62.1611959 17.5174071,63.8481143 15.8841929,64.5224 C14.0906929,65.260502 12.4951214,64.5886245 11.2383357,63.548298 C10.3604071,62.8198286 9.38533571,62.4778694 8.40419286,62.5164 C6.42247857,62.5910531 4.09105,61.5820327 1.67583571,58.2081959 C-2.43452143,52.4635224 -2.09209286,46.0000122 -1.25787857,41.9603184 C-0.718735714,39.3558898 -1.20202143,36.4384 -2.44909286,34.1976041 C-3.30273571,32.6636041 -4.26445,30.7358694 -5.11202143,28.5528694 C-7.26495,23.0104816 -7.73123571,17.6125837 -4.72587857,13.8281551"
                id="Fill-95"
                fill="#2D344B"
                mask="url(#mask-8)"
              />
            </g>
            <g
              id="Group-106"
              transform="translate(297.000000, 152.000000)"
              fill="#FFCDAB"
            >
              <path
                d="M38.9466243,39.4519186 C32.0708562,39.9476609 17.8477837,33.3908362 15.4347692,32.2739083 C13.0205518,31.1581867 0.0364648706,19.2724341 0.0364648706,19.2724341 C0.0364648706,19.2724341 -4.50153024,15.615427 -4.95622589,14.5708703 C-5.40971865,13.5251074 -0.388158318,16.0097021 -0.388158318,16.0097021 C-0.388158318,16.0097021 -0.0535551947,15.4459661 0.839329063,16.1237846 C1.73221332,16.8016031 2.03808806,17.8515475 2.03808806,17.8515475 C2.03808806,17.8515475 14.7791895,24.4915991 18.2784214,25.6423001 C30.9353199,29.8024341 38.0673055,28.4454753 39.0380446,29.1293826 C40.9963634,30.5092589 45.8235953,38.9549702 38.9466243,39.4519186 Z"
                id="Fill-98"
                transform="translate(18.765741, 26.896287) rotate(-105.000000) translate(-18.765741, -26.896287) "
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/_shared/ReadOnly.svg.jsx